import * as actionTypes from './ActionTypes';
import { setDefaultReducer } from '../helpers/Reducer';

export const setSession = setDefaultReducer(actionTypes.SET_SESSION);
export const clearSession = setDefaultReducer(actionTypes.CLEAR_SESSION);
export const setShowVirtualAccount = setDefaultReducer(
    actionTypes.SET_SHOW_VACCOUNT_MODAL
);
export const setVirtualAccount = setDefaultReducer(actionTypes.SET_VACCOUNT);
export const setTagnameId = setDefaultReducer(actionTypes.SET_TAGNAME_ID);
